import { appconfigkeysReducer } from './appconfigkeys.reducer';
import { appsReducer } from './applifecycle.reducer';
import { authReducer } from './auth.reducer';
import { datamodelReducer } from './datamodel.reducer';
import { documentsReducer } from './documents.reducer';
import { fileattachmentsReducer } from './fileattachments.reducer';
import { loginmethodReducer } from './loginmethod.reducer';
import { menuReducer } from './menu.reducer';
import { propertiesReducer } from './propertypane.reducer';
import { rolesReducer } from './roles.reducer';
import { routerReducer } from './router.reducer';
import { screensReducer } from './screens.reducer';
import { servicesReducer } from './services.reducer';
import { technologystackReducer } from './technologystack.reducer';
import { templatesReducer } from './templates.reducer';
import { translationsReducer } from './translations.reducer';
import { userstoriesReducer } from './userstories.reducer';
import { orgManagementReducer } from './orgmanagement.reducer';
import { usersReducer } from './users.reducer';
import { sampleDataReducer } from './sampleData.reducer';
import { ccReducer } from './customcomponent.reducer';
import { tableAclReducer } from './tableacl.reducer';
import { codeGenerationReducer } from './codegeneration.reducer';
import { workflowReducer } from './workflow.reducer';
import { queryBuilderReducer } from './queryBuilder.reducer';
import { indexDesignerReducer } from './indexdesigner.reducer';
import { mailInfoReducer } from './mailinfo.reducer';
import { appDatamodelReducer } from './applicationdatamodel.reducer';
import { globalServiceReducer } from './globalservice.reducer';
import { exposedrestReducer } from './exposedrest.reducer';
import { consumedrestReducer } from './consumedrest.reducer';
import { aiAppDatamodelReducer } from './aiapplicationdatamodel.reducer';
import { generationsReducer } from './generations/generation.reducer';
import { moduleReducer } from './generations/module.reducer';
import { RoleInterimReducer } from './generations/role.reducer';
import { ScreenInterimReducer } from './generations/screen-interim.reducer';
import { processReducer } from './generations/process.reducer';
import { userStoryReducer } from './generations/userstory.reducer';
import { logsReducer } from './generations/summary.reducer';
import { reverseEngineeringInputReducer } from './generations/input.reducer';
import { ingestionAnalysisReducer } from './generations/doc-analysis.reducers';
import { aiDataModelGenerationReducer } from './generations/ai-datamodel.reducer';
import { userStoriesV2Reducer } from './userstoriesv2.reducer';
import { lookupDefinitionsReducer } from './lookupdefinitions.reducer';
import { utilReducer } from './util.reducer';
import { queryStringReducer } from './querystring.reducer';
import { aclpermissionReducer } from './generations/aclpermission.reducer';

export const reducers = {
  auth: authReducer,
  menu: menuReducer,
  properties: propertiesReducer,
  router: routerReducer,
  documents: documentsReducer,
  fileAttachments: fileattachmentsReducer,
  userStories: userstoriesReducer,
  loginMethod: loginmethodReducer,
  roles: rolesReducer,
  dataModel: datamodelReducer,
  templates: templatesReducer,
  screens: screensReducer,
  tecnologyStack: technologystackReducer,
  services: servicesReducer,
  translations: translationsReducer,
  appconigkeys: appconfigkeysReducer,
  apps: appsReducer,
  orgManagement: orgManagementReducer,
  users: usersReducer,
  sampleData: sampleDataReducer,
  customComponent: ccReducer,
  tableAclReducer: tableAclReducer,
  codegen: codeGenerationReducer,
  workflow: workflowReducer,
  queryBuilder: queryBuilderReducer,
  indexDesigner: indexDesignerReducer,
  mailInfo: mailInfoReducer,
  appDatamodel: appDatamodelReducer,
  globalService: globalServiceReducer,
  exposedrest: exposedrestReducer,
  consumedrest: consumedrestReducer,
  aiAppDataModel: aiAppDatamodelReducer,
  lookupDefinitions: lookupDefinitionsReducer,
  queryString: queryStringReducer,
  generations: generationsReducer,
  generationRoles: RoleInterimReducer,
  screenInterim: ScreenInterimReducer,
  generationModules: moduleReducer,
  generationProcess: processReducer,
  generationUserStory: userStoryReducer,
  generationSummary: logsReducer,
  generationInput: reverseEngineeringInputReducer,
  generationIngestDocAnalysis: ingestionAnalysisReducer,
  generationsAiDataModel: aiDataModelGenerationReducer,
  userStoryV2: userStoriesV2Reducer,
  generationAclPermissions: aclpermissionReducer,
  util: utilReducer
};
